<template @click.stop="dialog = false">
  <div
    v-if="!loading"
    class="home"
    :class="screenType"
    :style="{ 'background-color': getAssets.colors.home.background, height: '100%', ...cssVars, ...cssVariables }"
  >
    <v-img :src="getImage" />

    <div class="home-grid" :class="hasStores ? 'home-grid-2' : 'home-grid-1'">
      <div class="d-flex justify-end" style="gap: 8px">
        <div class="allowed-countries">
          <v-select
            v-if="isInternacionalModuleActive"
            v-model="selectCountry"
            class="pr-0 input input-cpf"
            :items="allowedCountries"
            :color="getAssets.colors.home.input"
            item-text="label"
            item-value="value"
            outlined
            dense
            full-width
            width="95"
          >
            <template #item="{ item, attrs }">
              <v-list-item-content>
                <v-list-item-title class="country-select-item">
                  <img class="flag" v-bind="attrs.icon" :src="require(`@/assets/${item.icon}`)" /> <span style="color: #4b525a">{{ item.label }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <template #selection="{ item, attrs }">
              <v-list-item-content>
                <v-list-item-title style="position: absolute; font-size: 25px">
                  <img class="flag" :src="require(`@/assets/${item.icon}`)" />
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:label>
              <span :style="{ color: getAssets.colors.home.input }"> País </span>
            </template>
          </v-select>
        </div>
        <v-text-field
          v-if="isBrazilSelectedCountry"
          :key="inputCpfCnpj"
          v-model="cpfCnpj"
          v-mask="documentMask"
          outlined
          dense
          name="cpfCnpj"
          :error-messages="errors.first('cpfCnpj') || error"
          class="input input-cpf pl-0"
          :placeholder="inputPlaceholder"
          :color="getAssets.colors.home.input"
          autofocus
          @focus="isKeyboardOpened = true"
          @blur="isKeyboardOpened = false"
          @keyup.enter="next"
        >
          <template v-slot:append-outer>
            <v-btn
              height="40"
              :disabled="![11, 14].includes(cpfCnpjRaw.length)"
              :color="getAssets.colors.home.buttonBackground"
              :style="{ color: getAssets.colors.home.buttonFont }"
              :loading="loadingId"
              @click="next"
            >
              {{ screenType == 'smartphone' ? 'Ir' : 'Continuar' }}
            </v-btn>
          </template>
          <template v-slot:label>
            <span :style="{ color: getAssets.colors.home.input }">
              {{ inputLabel }}
            </span>
          </template>
          <template v-slot:message="{ message }">
            <div class="error-msg">
              <v-icon class="material-icons-round pr-1" size="20" :color="getAssets.colors.home.input">warning</v-icon>
              <span :style="{ color: getAssets.colors.home.input }">{{ message }}</span>
            </div>
          </template>
        </v-text-field>
        <v-text-field
          v-else
          :key="inputForeignDocument"
          v-model="foreignDocument"
          outlined
          autofocus
          dense
          name="Documento"
          :error-messages="error"
          class="input input-cpf pl-0"
          :placeholder="inputPlaceholder"
          :color="getAssets.colors.home.input"
          @focus="isKeyboardOpened = true"
          @blur="isKeyboardOpened = false"
          @keyup="removeCharacters"
        >
          <template v-slot:append-outer>
            <v-btn
              height="40"
              :disabled="foreignDocument.length === 0"
              :color="getAssets.colors.home.buttonBackground"
              :style="{ color: getAssets.colors.home.buttonFont }"
              :loading="loadingId"
              @click="nextForeigners"
            >
              {{ screenType == 'smartphone' ? 'Ir' : 'Continuar' }}
            </v-btn>
          </template>
          <template v-slot:label>
            <span :style="{ color: getAssets.colors.home.input }">
              {{ inputLabel }}
            </span>
          </template>
          <template v-slot:message="{ message }">
            <div class="error-msg">
              <v-icon class="material-icons-round pr-1" size="20" :color="getAssets.colors.home.input">warning</v-icon>
              <span :style="{ color: getAssets.colors.home.input }">{{ message }}</span>
            </div>
          </template>
        </v-text-field>
      </div>
      <div v-if="hasStores" class="qr-code-menu_home">
        <qr-codes-menu :stores="getAppStores" />
      </div>
    </div>
  </div>
</template>

<script>
import { documentMaskMixin } from '@/mixins/document-mask'
import { screenTypeMixin } from '@/mixins/screen-type'
import { validateCpf, validateCnpj } from '@/config/custom-validators.js'
import { argentinianDocumentValidator, uruguayanDocumentValidator } from '@/helpers/foreign-docs-validator.js'
import QrCodesMenu from '../components/QrCodesMenu.vue'
export default {
  components: { QrCodesMenu },
  mixins: [screenTypeMixin, documentMaskMixin],
  data: () => ({
    env: process.env,
    cpfCnpj: '',
    cpfCnpjRaw: '',
    isKeyboardOpened: false,
    error: '',
    text: '',
    foreignDocument: '',
    inputCpfCnpj: 0,
    inputForeignDocument: 0
  }),
  computed: {
    selectCountry: {
      get() {
        return this.selectedCountry
      },
      set(value) {
        this.$store.commit('SELECTED_COUNTRY', value)
      }
    },
    cssVars() {
      return {
        '--font-color': this.getAssets.colors.home.input
      }
    },
    inputLabel() {
      return this.allowedDocumentNames.join('/')
    },
    inputPlaceholder() {
      return this.screenType === 'smartphone'
        ? `Digite seu ${this.allowedDocumentNames.join(' ou ')}`
        : `Digite seu ${this.allowedDocumentNames.join('/')} para continuar`
    },
    allowedDocumentNames() {
      let documentNameMapper
      if (this.selectedCountry === 'ARGENTINA') {
        documentNameMapper = { N: 'CUIL', L: 'CUIT' }
      } else if (this.selectedCountry === 'URUGUAY') {
        documentNameMapper = { N: 'CI', L: 'RUT' }
      } else {
        documentNameMapper = { N: 'CPF', L: 'CNPJ' }
      }
      return this.getAllowedPersonTypesSignups.map(el => documentNameMapper[el])
    },
    getFields() {
      return this.$store.getters.GET_FIELDS
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    loading() {
      return this.$store.getters.LOADING
    },
    loadingId() {
      return this.$store.getters.LOADING_ID
    },
    accountId() {
      return this.$store.getters.GET_ACCOUNT_ID
    },
    getAllowedPersonTypesSignups() {
      return this.$store.getters.GET_ALLOWED_PERSON_TYPES_SIGNUP
    },
    getAppStores() {
      return this.$store.getters.APP_STORES
    },
    hasStores() {
      return this.getAppStores.enable_apps && (this.getAppStores.app_store_link || this.getAppStores.play_store_link)
    },
    getImage() {
      if (this.screenType === 'smartphone') return this.getAssets.images.home.smartphone
      if (this.screenType === 'tablet') return this.getAssets.images.home.tablet
      return this.getAssets.images.home.desktop
    },
    cssVariables() {
      return {
        '--home_input_color': this.getAssets.colors.home.input
      }
    }
  },
  watch: {
    cpfCnpj() {
      this.cpfCnpjRaw = this.cpfCnpj.length > 0 ? this.cpfCnpj.replace(/[^0-9]/g, '') : ''
    },
    selectedCountry() {
      this.foreignDocument = ''
      this.cpfCnpj = ''
      this.error = ''
      this.forceRerenderInputs()
    }
  },
  methods: {
    forceRerenderInputs() {
      this.inputCpfCnpj += 1
      this.inputForeignDocument += 1
    },
    redirect(route, value) {
      let key = ''
      let doc = ''
      if (this.selectedCountry === 'ARGENTINA') {
        doc = argentinianDocumentValidator(value)
        key = doc === 'CUIL' ? 'natural' : 'legal'
      } else if (this.selectedCountry === 'URUGUAY') {
        doc = uruguayanDocumentValidator(value)
        key = doc === 'CI' ? 'natural' : 'legal'
      } else {
        key = value.length === 11 ? 'natural' : 'legal'
      }
      this.$router.push({
        path: route,
        query: { [key]: value }
      })
    },
    next() {
      let fieldLength = this.cpfCnpjRaw.length
      if (fieldLength < 11) return
      this.checkId(this.cpfCnpjRaw)
    },
    removeCharacters() {
      this.foreignDocument = this.foreignDocument.replace(/[^0-9]/g, '')
    },
    async nextForeigners() {
      if (!this.foreignDocument) {
        this.error = 'Ops, esse número parece estar incorreto.'
        return
      }
      if (this.selectedCountry === 'ARGENTINA') {
        if (!argentinianDocumentValidator(this.foreignDocument)) {
          this.error = 'Ops, esse número parece estar incorreto.'
          return
        }
      } else {
        if (!uruguayanDocumentValidator(this.foreignDocument)) {
          this.error = 'Ops, esse número parece estar incorreto.'
          return
        }
      }
      await this.$store
        .dispatch('checkUniqueUser', { username: this.foreignDocument })
        .then(response => {
          if (response.consumerExists) this.redirect('cliente-cadastrado', this.foreignDocument)
          else this.redirect('cadastro', this.foreignDocument)
        })
        .catch(data => {
          if (data.response && data.response.errors && data.response.errors[0].message === 'User not allowed') {
            this.$snackbar({
              message: 'Não é possível cadastrar este CPF/CNPJ.',
              snackbarColor: 'error'
            })
          } else {
            this.redirect('contato', '')
          }
        })
    },
    isInputValid() {
      let fieldLength = this.cpfCnpjRaw.length
      if (fieldLength === 11) {
        return validateCpf(this.cpfCnpjRaw)
      } else if (fieldLength === 14) {
        return validateCnpj(this.cpfCnpjRaw)
      } else {
        return false
      }
    },
    async checkId(id) {
      if (!this.isInputValid()) {
        this.error = 'Ops, esse número parece estar incorreto.'
        return
      }
      await this.$store
        .dispatch('checkUniqueUser', { username: id })
        .then(response => {
          if (response.isBlocked) {
            this.$snackbar({
              message: 'Não é possível cadastrar este CPF/CNPJ.',
              snackbarColor: 'error'
            })
          } else if (response.consumerExists) this.redirect('cliente-cadastrado', id)
          else this.redirect('cadastro', id)
        })
        .catch(data => {
          if (data.response && data.response.errors && data.response.errors[0].message === 'User not allowed') {
            this.$snackbar({
              message: 'Não é possível cadastrar este CPF/CNPJ.',
              snackbarColor: 'error'
            })
          } else {
            console.warn(data)
            // TODO: Add the snackbar element
          }
        })
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;

.error-msg {
  display: flex;
  align-items: center;
}
.icon {
  display: flex;
  justify-content: center;
  span {
    color: #4caf50 !important;
    font-size: 80px;
    margin-top: 20px;
    margin-bottom: 0;
  }
}
.v-card__title.headline {
  word-break: break-word !important;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500 !important;
  font-size: 20px !important;
  line-height: 120% !important;
  text-align: center !important;
  letter-spacing: 0.01em !important;
  display: block;
}
.v-card__text {
  padding-top: 10px !important;
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    letter-spacing: 0.02em;
    color: #6b7580;
    margin-bottom: 0;
  }
}
.v-btn:not(.v-btn--round).v-size--x-large {
  height: 56px;
}
.btn-modal {
  justify-content: flex-end;
  .v-btn__content {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }
}
.home {
  .relative-container {
    position: relative;
  }

  .container,
  &.smartphone {
    .layout {
      padding: 20px 0 0;
    }
    .v-input__control {
      .v-input__slot {
        width: 310px;
      }
    }
    .theme--light.v-input {
      margin-top: 10px;
      padding: 0 30px;
    }
  }
  &.smartphone {
    .v-input__control {
      .v-input__slot {
        width: auto;
      }
    }
  }
  .v-input__control {
    flex-grow: unset;
    width: auto;
    .v-input__slot {
      width: 380px;
    }
  }

  .v-btn {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }
  .v-text-field--outlined .v-input__prepend-outer,
  .v-text-field--outlined .v-input__append-outer {
    margin-bottom: 0;
    margin-top: 0 !important;
  }
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0 !important;
  }
  .input-cpf input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: var(--font-color) !important;
    opacity: 1; /* Firefox */
  }

  .input-cpf input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: var(--font-color) !important;
  }

  .input-cpf input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: var(--font-color) !important;
  }
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: rgba(185, 185, 185, 1) !important;
  }
}
.allowed-countries {
  .v-input__slot {
    width: 95px !important;
  }
}
.country-select-item {
  display: flex;
  place-items: center;
  gap: 10px;
  height: 24px;
}
input {
  color: var(--home_input_color) !important;
}
.v-input__icon > i {
  color: var(--home_input_color) !important;
}
.v-input__slot > fieldset {
  border-color: var(--home_input_color) !important;
  color: var(--home_input_color) !important;
}

.home-grid {
  padding: 24px 32px 0;
  display: grid;
  justify-items: center;
}

.home-grid-1 {
  grid-template-columns: 1fr;
}

.home-grid-2 {
  grid-template-columns: 1fr 216px;
}

@media screen and (max-width: 1260px) {
  .home-grid {
    gap: 40px;
    padding-bottom: 24px;
  }

  .home-grid-2 {
    grid-template-columns: 1fr;
  }
}

@media screen and (min-width: 1261px) {
  .home-grid-2 {
    margin-left: 216px;
  }
}

@media only screen and (max-width: 991px) {
  .qr-code-menu_home {
    margin-top: -27px;
    margin-bottom: 44px;
  }
}
</style>
